import React from 'react';
import { View, Text } from 'react-native';
import { useThemedStyles } from '@/hooks/residents/useThemeColors';

interface InfoRowProps {
  label: string;
  value: string;
  variant?: 'mobile' | 'desktop';
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  const styles = useInfoRowStyles();

  return (
    <View style={styles.infoRow}>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.value}>{value}</Text>
    </View>
  );
};

const useInfoRowStyles = () =>
  useThemedStyles(({ colors }) => ({
    infoRow: {
      flexDirection: 'row' as const,
      justifyContent: 'space-between' as const,
      alignItems: 'center' as const,
    },
    label: {
      fontSize: 14,
      fontWeight: '500' as const,
      color: colors.text.primary,
      lineHeight: 21,
    },
    value: {
      fontSize: 14,
      fontWeight: '400' as const,
      color: colors.text.muted,
      lineHeight: 21,
      textAlign: 'right' as const,
    },
  }));
